export default __webpack_public_path__ + "static/agency-c69e45a8e9ba11d4b1e712ca6efac5fc.jpg";